import { ComponentChild, h, Component } from 'preact'
import { PureComponent } from 'preact-compat'

type OnChange = (newValue: string) => void
type OnEnter = () => void

const handleEnter = (e: KeyboardEvent, onEnter: OnEnter | undefined) => {
  if (e.key === 'Enter' && onEnter) {
    e.preventDefault()
    e.stopPropagation()
    onEnter()
  }
}

const handleChange = (e: KeyboardEvent, onChange: OnChange) => {
  if (e.target instanceof HTMLInputElement && onChange) {
    onChange(e.target.value)
  }
}

interface Props {
  attributes: {
    type?: string,
    placeholder?: string,
    value?: string
  },
  initialValue?: string,
  className?: string,
  preIcon?: ComponentChild,
  postIcon?: ComponentChild,
  onEnter?: OnEnter,
  onChange: OnChange
}

class InputGroup extends PureComponent<Props> {
  constructor(props: Props) {
    super(props)
  }

  render (props: Props) {
    return <div className='form-group'>
      <div className='input-wrapper'>
        { props.preIcon ? (
          <span className='pre-icon-wrapper input-icon-wrapper'>
            { props.preIcon }
          </span>
        ) : null }
        <Input
          {...props}
        />
        { props.postIcon ? (
          <span className='post-icon-wrapper input-icon-wrapper'>
            { props.postIcon }
          </span>
        ) : null }
      </div>
    </div>
  }
}

class Input extends Component<Props> {

  shouldComponentUpdate (nextProps: Props) {
    return this.props.attributes.value !== nextProps.attributes.value
    || this.props.attributes.placeholder !== nextProps.attributes.placeholder
    || this.props.postIcon !== nextProps.postIcon
    || this.props.onChange !== nextProps.onChange
    || this.props.onEnter !== nextProps.onEnter
    || this.props.className !== nextProps.className
  }

  render (props: Props) {
    return <input
        className={`input-group ${props.className} ${props.postIcon ? 'has-post-icon' : ''}`}
        onKeyUp={(e: KeyboardEvent) => handleChange(e, value => {
            props.onChange(value)
        })}
        onKeyDown={(e: KeyboardEvent) => handleEnter(e, props.onEnter)}
        value={props.initialValue}
        {...props.attributes}
      />
  }
}

export default InputGroup
